<mat-toolbar class="content-header">
  <h1 class="forge-title">
    <div class="title">
      <mat-icon fontIcon="view_in_ar"></mat-icon>
      {{'menu.viewer.3d' | translate}}
    </div>

    <div class="actions-btn">
      <lib-button color="secondary" icon="refresh" tooltip="{{'menu.viewer.reset_viewer' | translate}}"
        (click)="resetViewer()" [loading]="resetting" customClass="refresh-btn">
      </lib-button>

      <lib-button color="primary" (click)="goToSettings()" icon="settings"
        tooltip="{{'viewer.setting_model' | translate}}">
      </lib-button>
    </div>
  </h1>

</mat-toolbar>

<ng-container *ngIf="model && model.urn && showViewer">
  <div class="viewer {{playMode}}" [ngClass]="{ 'timeline': showTimeline }">
    <adsk-forge-viewer [viewerOptions]="viewerOptions" (onDocumentChanged)="documentChanged($event)">
    </adsk-forge-viewer>
  </div>
</ng-container>

<app-player [units$]="units$" (onPlayerChanged)="onPlayerChanged($event)"
  (onTrackerPositionsChanged)="onTrackerPositionsChanged($event)" class="{{ showTimeline ? 'timeline' : ''}}">
</app-player>


<ng-container *ngIf="!error && model">
  <h4 *ngIf="model.status == 'processed' && !model.urn">
    {{'viewer.no_urn' | translate}}
  </h4>

  <h4 *ngIf="model.status == 'translating' && !model.urn">
    {{'viewer.no_urn' | translate}}
  </h4>

  <h4 *ngIf="model.status == 'ready' && !model.urn">
    {{'viewer.no_active_model' | translate}}
  </h4>
</ng-container>

<ng-container *ngIf="error || !model">
  <h4 *ngIf="error">
    {{error}}
  </h4>

  <h4 *ngIf="!error && !model">
    {{'viewer.no_active_model' | translate}}
  </h4>
</ng-container>